import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from 'shells/icon/svg/checkmark-icon';
import {WarningIcon} from 'shells/icon/svg/warning-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Popover} from 'shells/popover/popover';

import type {FromDomainStatus} from 'nutshell-graphql-types';

type Props = {
    status: FromDomainStatus;
    onRetry: () => Promise<any>;
};

export function GroupTableStatus(props: Props) {
    const [isShowingPopover, setIsShowingPopover] = React.useState(false);
    const {status, onRetry} = props;
    const popoverAnchor = React.useRef(null);

    let Icon = WarningIcon;
    let color: string = colors.orangeAttention;
    let text = 'DNS not configured';
    let textColor: string | undefined = colors.orangeAttention;
    let action;
    let buttonText;

    switch (status) {
        case 'STATUS_VERIFIED':
            Icon = CheckmarkIcon;
            color = colors.green;
            text = 'Verified';
            textColor = undefined;
            action = null;
            break;
        case 'STATUS_FAILED':
            text = 'Verification failed';
            action = onRetry;
            buttonText = 'Retry';
            break;
        case 'STATUS_UNCONFIGURED':
            action = () => setIsShowingPopover(true);
            buttonText = 'Fix this';
            break;
        case 'STATUS_VERIFYING':
            text = 'Verifying…';
            break;
    }

    return (
        <>
            <div className='font-size-small flex align-center'>
                {/* @ts-expect-error */}
                <Icon className='mr-8' color={color} size={13} alignCenter={true} />
                <span className='mr-8' style={{color: textColor}}>
                    {text}
                </span>
                {action && buttonText && (
                    <Button
                        onClick={action}
                        size='small'
                        variant='text-primary'
                        noPadding={true}
                        getButtonRef={popoverAnchor}
                    >
                        {buttonText}
                    </Button>
                )}
            </div>
            {isShowingPopover && (
                <Popover anchor={popoverAnchor.current} bodyColor='dark'>
                    <div className='pad-16' style={{width: '250px'}}>
                        <StackLegacy spacing={8}>
                            <div>
                                Make sure the records in this table are added to your DNS provider.
                                After that, select ’Check for records’ to confirm their correct
                                setup.
                            </div>
                            <div className='flex align-center'>
                                <div className='mr-8'>Not sure what that means?</div>
                                {/* TODO update link */}
                                <Link size='small' variant='primary' href='#' newTab={true}>
                                    Let us explain!
                                </Link>
                            </div>
                            <Button
                                onClick={() => onRetry().then(() => setIsShowingPopover(false))}
                                variant='primary'
                                size='small'
                                isFullWidth={true}
                            >
                                Check for records
                            </Button>
                        </StackLegacy>
                    </div>
                </Popover>
            )}
        </>
    );
}
